import { render, staticRenderFns } from "./UserAuthorisation.vue?vue&type=template&id=7fd55e82&"
import script from "./UserAuthorisation.vue?vue&type=script&lang=js&"
export * from "./UserAuthorisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports